// extracted by mini-css-extract-plugin
export default {"footer":"Legal_footer__IL8SH","archive":"Legal_archive__7UdIe"};